var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgHome = function SvgHome(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.219 2.96c.415-.391 1.115-.391 1.563 0l9.481 8.295c.493.434.541 1.182.111 1.674a1.19 1.19 0 0 1-1.674.111L12 5.426 3.3 13.04a1.186 1.186 0 0 1-1.561-1.785z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12 5.426 8.3 7.262.015 7.456a1.48 1.48 0 0 1-1.481 1.485h-2.982a1.48 1.48 0 0 1-1.481-1.481v-3.27c0-.656-.53-1.186-1.185-1.186h-2.37c-.656 0-1.186.53-1.186 1.185v3.27c0 .82-.663 1.482-1.481 1.482h-2.96a1.46 1.46 0 0 1-1.482-1.481l-.002-7.463z"
  })));
};
export default SvgHome;